<script async setup>
import EmojioneSnail from '~icons/emojione/snail'
import MaterialSymbolsContentCopyOutlineRounded from '~icons/material-symbols/content-copy-outline-rounded'
import OpenmojiInternetExplorer from '~icons/openmoji/internet-explorer'
import StreamlineEmojisEMail2 from '~icons/streamline-emojis/e-mail-2'
import { useSEO } from '~/composables/seo'

function copyEmail() {
  // console.log('copoed email')
  navigator.clipboard.writeText('crappyquiz@offtheball.com')
}

const { GenerateTags } = useSEO()
GenerateTags({ title: '⁉️ ️Whut?', desc: 'What is this nonsense?' })
</script>

<template>
  <div class="h-auto">
    <div class="flex justify-center">
      <div class="max-w-[605px]">
        <div
          class="mt-6 mx-3 sm:mx-0 sm:m-y-8 mb-10 p-4 border rounded-md border-red-300 text-sm paper-shadow dark:border-red-800 dark:bg-gray-800"
        >
          <span class="text-gray-700 sg-regular text-lg dark:text-gray-50">The Crappy Quiz is a weekly sports quiz show every Friday on
            <NuxtLink
              class="underline decoration-2"
              href="https://www.otbsports.com/"
              rel="noopener"
              target="_blank"
            >OTB Sports</NuxtLink>. Episodes from Aug 11<sup>th</sup> 2023 are pay-walled. <span class="text-2xl"><span
              class="align-middle"
            >💵</span></span>
          </span>
          <div class="py-6 flex justify-center">
            <span class="ml-1 text-lg">👉</span>
            <span class="items-center ml-1 text-gray-700 sg-regular text-lg dark:text-gray-50">
              <NuxtLink
                class="underline decoration-wavy decoration-1 wavy-text"
                href="https://www.youtube.com/c/OffTheBall"
                rel="noopener"
                target="_blank"
              >
                Go watch and subscribe on the YT channel</NuxtLink></span>
          </div>

          <div class="text-lg line-shadow p-2 bg-green-200 border-4 border-green-400 ">
            Sports brainiacs can send quiz questions & answers to:
          </div>

          <div class="h-30 flex items-center relative justify-center sm:space-x-6 group dark:text-gray-300 m-y-8">
            <div class="absolute -top-2 left-0 sm:top-0 sm:left-0">
              <OpenmojiInternetExplorer class="text-3xl imageRotateHorizontal absolute z-100" />
              <div class="text-sm relative -skew-7 top-6">
                via internetz
              </div>
            </div>
            <StreamlineEmojisEMail2 class="text-5xl" />
            <div class="flex w-auto items-center justify-center">
              <div class="sg-semibold text-lg sm:text-xl">
                crappyquiz@offtheball.com
              </div>
              <div
                v-tooltip="{
                  content: 'Click to copy',
                  theme: 'customTip' }
                "
                class="hidden sm:flex sm:w-6 cursor-pointer"
              >
                <MaterialSymbolsContentCopyOutlineRounded
                  class="group-hover:flex hidden text-gray-800 pl-2 text-4xl"
                  @click="copyEmail"
                />
              </div>
            </div>
          </div>

          <div
            class="h-50 sm:h-70 border-3 border-green-300 border-rounded border-dashed relative flex mt-10"
          >
            <div class="absolute -top-15 sm:-top-14">
              <EmojioneSnail class="text-3xl animate-bounce" />
              <div class="text-sm relative -top-1 sm:-top-2 -skew-7 dark:text-gray-300">
                or snail mail
              </div>
            </div>
            <div class="flex items-center justify-center w-full pt-0">
              <!--              <div class="i-fluent-emoji-open-mailbox-with-raised-flag text-6xl absolute -right-6 -top-8 rotate-13" /></div> -->
              <div class="flex flex-row items-center w-full">
                <div class="w-1/3">
                  <div class="flex justify-center align-middle items-center">
                    <NuxtImg
                      class="items-center w-35 sm:w-40"
                      src="/images/post-box.png"
                    />
                  </div>
                </div>

                <div
                  class="se-regular w-2/3 dark:text-gray-300 sm:text-xl underline underline-green-400 underline-dashed underline-4 flex"
                >
                  <div class="flex items-center w-full">
                    <div class="border-2 border-dashed px-2 mr-4 relative w-full">
                      <div>
                        <NuxtImg
                          src="/images/stamp.png"
                          class="absolute -top-6 -right-2.5 sm:-top-8 w-8 sm:w-12 sm:-right-2"
                        />
                      </div>
                      <span class="flex">'Crappy Quiz' Quiz Master</span>
                      <span class="flex">Off the Ball Towers</span>
                      <span class="flex">Marconi House</span>
                      <span class="flex">Digges Lane</span>
                      <span class="flex">Dublin 2</span>
                      <span class="flex">D02 TD60</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.paper-shadow {
  box-shadow:
    rgb(255, 255, 255) 4px 4px 0 -1px,
    rgba(34, 197, 94, 0.5) 4px 4px,
    rgb(255, 255, 255) 8px 8px 0 -1px,
    rgba(34, 197, 94, 0.5) 8px 8px;
}

.wavy-text {
  text-decoration-line: underline;
  text-decoration-style: wavy;
  text-decoration-color: red;
}

html.dark .paper-shadow {
  box-shadow:
    #1f2937 4px 4px 0 -1px,
    rgba(34, 197, 94, 0.5) 4px 4px,
    #1f2937 8px 8px 0 -1px,
    rgba(34, 197, 94, 0.5) 8px 8px;
}

.line-shadow {
  box-shadow:
    4px 4px #ec1d23,
    8px 8px #f8df26;
}

.imageRotateHorizontal {
  -moz-animation: spinHorizontal 2.8s infinite linear;
  -o-animation: spinHorizontal 2.8s infinite linear;
  -webkit-animation: spinHorizontal 2.8s infinite linear;
  animation: spinHorizontal 2.8s infinite linear;
}

@keyframes spinHorizontal {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}
</style>
